// ----------------------------------------------------------------
// <copyright company="Microsoft Corporation">
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

// Redirect to https:// protocol version of deployed site so AAD doesn't complain about Reply Url mismatch
if (!window.location.hostname.toUpperCase().includes('LOCALHOST') && window.location.protocol !== 'https:') {
    window.location.replace(window.location.href.replace('http:', 'https:'));
}

import React from 'react';
import ReactDOM from 'react-dom';

import * as serviceWorker from './serviceWorker';
import { isBrowserSupported } from './helpers/browser';

import './index.module.scss';

// MSAL imports
import { PublicClientApplication, EventType, EventMessage, AuthenticationResult } from '@azure/msal-browser';
import { msalConfig } from './lib/authConfig';

import App from './App';

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

export const msalInstance = await PublicClientApplication.createPublicClientApplication(msalConfig);

// Account selection logic is app dependent. Adjust as needed for different use cases. Use Effect - TODO
const accounts = msalInstance.getAllAccounts();
if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0]);
}

msalInstance.addEventCallback((event: EventMessage) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
        const payload = event.payload as AuthenticationResult;
        const account = payload.account;
        msalInstance.setActiveAccount(account);
    }
});

// Need to conditionally import the app else the entire DOM will crash in IE
if (isBrowserSupported()) {
    require('./lib/i18n');
    require('./lib/ApplicationInsights');

    const root = document.getElementById('root');
    if (root) {
        //const App = require('./App');
        ReactDOM.render(
            <App pca={msalInstance}/>,
            document.getElementById('root') as HTMLElement
        );
    }
}